{
  "receive.heading": "Recibir",
  "receive.description": "Esta página muestra el estado, el ciclo y la cantidad de contenedores y paquetes en proceso de recepción",
  "receive.filter.title": "Opciones",
  "receive.filter.cycle": "Ciclo",
  "status.current_planned": "Planeado actualmente",
  "status.planned_inducted": "Corriente inducida real",
  "status.unplanned_inducted": "Otro/Inducción real no planificada",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "Inducir por",
  "CPT.stow_by": "Almacenar POR",
  "receive.overall_status": "Estado general",
  "receive.packages": "Paquetes",
  "receive.predicted_dispatch": "Envío previsto (LMCP)",
  "receive.total_manifested": "Manifestación total",
  "receive.container_planned_volume": "Volumen planificado del contenedor",
  "receive.current_cycle_planned": "Ciclo actual planificado",
  "receive.current_cycle_actual": "El ciclo actual llegó de forma real",
  "receive.other_cycles": "Otro ciclo o no planificado llegó real",
  "receive.current_planned": "Planeado actualmente",
  "receive.current_actual": "La corriente llegó real",
  "receive.other": "Otro/No planificado llegó real",
  "receive.total": "El total llegó real",
  "status.planned_inducted_cycle": "Ciclo actual inducido de forma real",
  "status.unplanned_inducted_cycle": "Actual inducido por otro ciclo o no planificado",
  "status.current_cycle_planned": "Ciclo actual planificado",
  "status.total_inducted": "Total real inducido",
  "receive.current_status": "Estado actual",
  "receive.manifested": "Manifestado",
  "receive.manifested.unplanned": "Manifestado de forma no planificada",
  "receive.in_transit": "En tránsito",
  "receive.in_transit.unplanned": "No planificado en tránsito",
  "receive.arrived": "Llegó",
  "receive.arrived.unplanned": "Llegó sin planificar",
  "receive.marked_for_reprocess": "Marcado para ser reprocesado",
  "receive.marked_for_reprocess.unplanned": "Lo no planificado está marcado para ser reprocesado",
  "receive.inducted": "Inducido",
  "receive.stow_buffered": "Almacenamiento en búfer",
  "receive.stowed": "Guardado",
  "receive.sidelined": "Dejado de lado",
  "receive.group_by": "Agrupar por",
  "linehaul.linehauls": "Transportes de línea",
  "linehaul.status": "Estado",
  "linehaul.arrival": "Llegada",
  "linehaul.details": "Detalles",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "Origen",
  "linehaul.location": "Ubicación",
  "linehaul.planned": "Planificado",
  "linehaul.actual": "Actual",
  "linehaul.volume": "Volumen",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "Secuencia de descarga",
  "linehaul.inyard": "En el patio",
  "linehaul.arrived": "Llegó",
  "linehaul.incoming": "Entrante",
  "linehaul_detail.receive": "Recibir",
  "linehaul_detail.linehaul_details": "Detalles de la línea",
  "linehaul_detail.linehaul": "Transporte de línea",
  "linehaul_detail.from": "Desde",
  "linehaul_detail.departed": "Partido",
  "linehaul_detail.arrived": "Llegó",
  "linehaul_detail.options": "Opciones",
  "linehaul_detail.id": "ID",
  "linehaul_detail.type": "Tipo",
  "linehaul_detail.pending_induct": "Inducción pendiente",
  "linehaul_detail.total": "Total",
  "linehaul_filter.packagesize": "Tamaño del paquete",
  "linehaul_filter.ead": "Estación EAD",
  "linehaul_filter.cycle": "Ciclo",
  "linehaul_filter.cluster": "Clúster",
  "linehaul_filter.unplanned": "No planificado",
  "linehaul_filter.sideline": "Línea lateral",
  "linehaul_filter.commercial": "Comercial",
  "linehaul_filter.cosmos": "Cosmos",
  "linehaul_filter.clear_all": "Borrar todo",
  "receivergroup.none": "Ninguno",
  "receivergroup.package_size": "Tamaño del paquete",
  "receivergroup.station_ead": "Estación EAD",
  "receivergroup.cluster": "Clúster",
  "receivergroup.cycle": "Ciclo",
  "linehaul_filter.otherattributes": "Otros atributos",
  "induct.heading": "Inducir",
  "induct.description": "Esta página muestra el estado, el ciclo y la cantidad de contenedores y paquetes en proceso de inducción",
  "induct.induct": "Inducir",
  "induct.induct_area": "Áreas de inducción",
  "induct.induct_type": "Tipo de inducción",
  "induct.manual": "Manual",
  "induct.automated": "Automatizado",
  "induct.active_associate": "Asociados activos",
  "induct.induct_rate": "Velocidad de inducción",
  "induct.total_inducted": "Total inducido",
  "induct.container": "Contenedor",
  "induct.container_id": "ID",
  "induct.type": "Tipo",
  "induct.pending_induct": "Inducción pendiente",
  "induct.total": "Total",
  "induct.aslInductArea": "Área de inducción de ASL",
  "induct.max_induct_rate": "Velocidad máxima de inducción",
  "induct.station_percentage": "% de la estación",
  "induct.successful_percentage": "% de éxito",
  "induct.kickout": "Expulsión",
  "induct.noread": "Sin lectura",
  "induct.timeout": "Tiempo de espera",
  "induct.failed_verification": "Fallo en la verificación",
  "induct.sidelined": "Dejado de lado",
  "induct.cycle": "Ciclo",
  "induct.unplanned": "No planificado",
  "associate.heading": "Incorporar asociados",
  "associate.description": "Esta página muestra los datos de rendimiento y la ubicación de trabajo actual de los asociados de Induct",
  "associate.yes": "Sí",
  "associate.no": "No",
  "associate.option": "Opciones",
  "associate.active": "Activo",
  "associate.associates": "Asociados",
  "associate.associate": "Asociado",
  "associate.pph": "PHP",
  "associate.hours": "Horas",
  "associate.total_packages": "Total de paquetes",
  "associate.location": "Ubicación",
  "associate.inactive_period": "Período inactivo",
  "package.package_summary": "Resumen del paquete",
  "package.tracking_id": "ID de seguimiento",
  "package.last_scan_date_time": "Último escaneo",
  "package.minutes_in_state": "Minutos en estado",
  "package.package_state": "Estado",
  "package.package_reason": "Motivo",
  "package.location": "Ubicación",
  "package.cycle": "Ciclo",
  "package.cpt": "CPT",
  "package.sort_zone": "Zona de clasificación",
  "package.cluster": "Clúster",
  "package.EAD": "Estación EAD",
  "package.size": "Tamaño",
  "package.station_code": "Destino",
  "package.package_list": "Lista de paquetes",
  "package.download": "Descargar",
  "induct.error": "Se ha producido algún error",
  "tooltip.predicated_lmcp": "Volumen previsto de LMCP",
  "tooltip.current_planned": "Planificador de clasificación (RTW) de envíos manifiestos",
  "tooltip.planned_inducted": "Envíos planificados que han llegado, han sido admitidos o están pendientes de reincorporación",
  "tooltip.unplanned_inducted": "Otros envíos que han llegado a la estación",
  "tooltip.manifested": "Envíos planificados para este momento y que se han enviado a un camión que está previsto llegar a la estación de entrega",
  "tooltip.unplanned_manifested": "Envíos no planificados para este momento y que se han enviado a un camión que está previsto llegar a la estación de entrega",
  "tooltip.in_transit": "Envíos planificados para este momento que se encuentran en un camión en tránsito hacia la estación de entrega",
  "tooltip.unplanned_in_transit": "Envíos no planificados para este momento y que estén en un camión en tránsito hacia la estación de entrega",
  "tooltip.arrived": "Envíos planificados para este momento que han llegado a la estación de entrega",
  "tooltip.unplanned_arrived": "Envíos NO planificados para este momento y que han llegado a la estación de entrega",
  "tooltip.marked_for_reprocess": "Envíos planificados para este momento que se han resuelto mediante Fixit",
  "tooltip.unplanned_marked_for_reprocess": "Envíos NO planificados para este momento y que se han resuelto mediante Fixit",
  "tooltip.inducted": "Los envíos se encuentran actualmente en este estado de paquete y se han admitido correctamente durante este tiempo",
  "tooltip.stowed": "Los envíos que se encuentran actualmente en este estado de paquete se han almacenado correctamente durante este tiempo",
  "tooltip.sidelined": "Los envíos que se encuentran actualmente en estado de paquete están retenidos (suspendidos) y han estado fuera de servicio durante este tiempo",
  "tooltip.current_cycle_planned": "Ordena los envíos manifiestos por planificador (RTW)",
  "tooltip.planned_cycle_inducted": "Envíos planificados que han llegado, han sido admitidos o están pendientes de reincorporación",
  "tooltip.unplanned_cycle_inducted": "Otros envíos que han llegado a la estación",
  "tooltip.total_inducted_cycle": "El ciclo actual llegó y otro ciclo no planificado llegó real",
  "tooltip.current_arrived": "Envíos planificados que han llegado, han sido admitidos o están pendientes de reincorporación",
  "tooltip.other_unplanned_arrived_actual": "Otros envíos que han llegado a la estación",
  "tooltip.current_cycle_arrived": "Envíos planificados que han llegado, han sido admitidos o están pendientes de reincorporación",
  "tooltip.other_unplanned_cycle_arrived_actual": "Otros envíos que han llegado a la estación",
  "tooltip.total_arrived_actual_cycle": "El ciclo actual llegó y otro ciclo no planificado llegó real",
  "tooltip.manifested_cycle": "Los envíos planificados para este ciclo se han trasladado a un camión que está previsto llegar a la estación de entrega",
  "tooltip.unplanned_manifested_cycle": "Envíos no planificados para este ciclo que se han enviado a un camión que está previsto llegar a la estación de entrega",
  "tooltip.in_transit_cycle": "Envíos planificados para este ciclo que se encuentran en un camión en tránsito hacia la estación de entrega",
  "tooltip.unplanned_in_transit_cycle": "Envíos NO planificados para este ciclo que van en un camión en tránsito hacia la estación de entrega",
  "tooltip.arrived_cycle": "Envíos planificados para este ciclo que han llegado a la estación de entrega",
  "tooltip.unplanned_arrived_cycle": "Envíos no planificados para este ciclo que han llegado a la estación de entrega",
  "tooltip.marked_for_reprocess_cycle": "Envíos planificados para este ciclo que se han resuelto mediante Fixit",
  "tooltip.unplanned_marked_for_reprocess_cycle": "Envíos NO planificados para este ciclo que se han resuelto mediante Fixit",
  "tooltip.inducted_cycle": "Los envíos que se encuentran actualmente en este estado de paquete y se han admitido correctamente durante este ciclo",
  "tooltip.stowbuffered_cycle": "Los envíos que se encuentran actualmente en este estado de paquete y se han almacenado correctamente en búfer durante este ciclo",
  "tooltip.stowed_cycle": "Envíos que se encuentran actualmente en este estado de paquete y se han almacenado correctamente durante este ciclo",
  "tooltip.sidelined_cycle": "Los envíos que se encuentran actualmente en estado de paquete están retenidos (suspendidos) y han estado fuera de servicio durante este ciclo",
  "tooltip.total_arrived_actual": "El paquete actual ha llegado más el resto o el que ha llegado de forma imprevista",
  "tooltip.max_induct_rate": "Velocidad de inducción máxima esperada para la máquina ASL. ",
  "tooltip.induct_rate": "Número promedio de paquetes introducidos por hora. ",
  "tooltip.total_inducted": "Número total de paquetes incluidos en el turno actual. ",
  "tooltip.station_percentage": "Porcentaje del volumen total de la estación que se introdujo con la máquina ASL. ",
  "tooltip.successful_percentage": "Porcentaje de paquetes que la máquina ASL escaneó correctamente. ",
  "tooltip.non_conveyable_description": "NC: paquetes que superan los 42\" en una sola dimensión. \nEs posible que FCLM tenga criterios de dimensión diferentes para NC",
  "tooltip.kickout": "Número de paquetes que fueron expulsados durante la incorporación al ASL. ",
  "tooltip.noread": "Número de paquetes procesados por ASL en los que la cámara de entrada no leyó un código de barras válido. ",
  "tooltip.timeout": "Número de escaneos de paquetes procesados por ASL que no recibieron una respuesta inductiva dentro del SLA. ",
  "tooltip.failed_verification": "Número de paquetes procesados por ASL que no fueron verificados por la cámara de salida. ",
  "generic.error": "Se ha producido algún error",
  "generic.close": "Cerrar",
  "generic.enabled": "Activado",
  "generic.disabled": "Desactivado",
  "header.induct_management": "Gestión de inductos",
  "induct_management.induct_setup": "Configuración de inducción",
  "induct_management.select_cycle": "Seleccione el ciclo",
  "induct_management.current_sort_cycle": "Ciclo de clasificación actual",
  "induct_management.current_cycle_state": "Estado actual del ciclo",
  "induct_management.current_force_induct_status": "Estado de inducción de la fuerza actual",
  "induct_management.enable_force_induct": "Activar la inducción de fuerza",
  "induct_management.sort_cycle": "Ciclo de clasificación",
  "induct_management.force_induct_sort_cycle": "Forzar la incorporación de todos los paquetes recibidos en el ciclo de clasificación actual",
  "induct_management.start_sort_cycle": "Iniciar la inducción",
  "induct_management.container_plan_failure": "Se ha producido un error al obtener el plan del contenedor. Vuelva a intentarlo más tarde",
  "induct_management.mapped_cycles_failure": "Se ha producido un error al recuperar Active Cycles. Vuelva a intentarlo más tarde",
  "induct_management.set_node_operational_failure": "Se ha producido un error al guardar el ciclo de inducción. Vuelva a intentarlo más tarde",
  "induct_management.get_node_operational_failure": "Se ha producido un error al obtener la información actual del ciclo de clasificación. Vuelva a intentarlo más tarde",
  "induct_management.non_mco_station": "Esta página aún no está habilitada para su estación. Si su estación admite operaciones de varios ciclos, esté atento para recibir más actualizaciones :-) ",
  "induct_management.bad_request": "Seleccione el ciclo correcto en el menú desplegable",
  "induct_management.set_node_induct_process_details_success": "El ciclo de inducción se inició correctamente",
  "induct_management.no_active_container_plans_available": "No hay planes de contenedores activos configurados para esta estación; inténtelo de nuevo más tarde",
  "induct_management.pick_started_for_the_current_cycle": "Se ha iniciado la selección para el ciclo actual, por lo que la inducción está bloqueada ",
  "induct_management.start_induct": ". Cambie al ciclo correcto e inicie el proceso de inducción. ",
  "common.data_last_updated": "Datos actualizados por última vez",
  "inductmanagement.heading": "Gestión del ciclo de inducción",
  "inductmanagement.description": "Esta página le permite cambiar la configuración del ciclo de inducción",
  "inductmanagement.manage_cycle": "Gestionar los ciclos",
  "inductmanagement.force_induct": "Inducción de fuerza",
  "inductmanagement.active_until": "Activo hasta",
  "inductmanagement.noCycles": "No hay ciclos disponibles",
  "inductmanagement.disableCycle": "Desactivar el ciclo",
  "inductmanagement.enableCycle": "Activar el ciclo",
  "inductmanagement.enterCycle": "Ingresar ciclo... ",
  "inductmanagement.enterStationCode": "Introduzca el código de estación... ",
  "inductmanagement.noStations": "No hay estaciones disponibles",
  "inductmanagement.selectStatus": "Seleccione el estado... ",
  "inductmanagement.enableForceInduct": "Habilitar la inducción de fuerza",
  "inductmanagement.disableForceInduct": "Desactivar la inducción de fuerza",
  "inductmanagement.activateSortToRouteError": "No se puede activar otro ciclo del tipo SORT_TO_ROUTE. {cycle} ya está activo. ",
  "inductmanagement.activateCycleError": "Se encontró un error al activar el ciclo: {cycle}",
  "inductmanagement.deactivateCycleError": "Se encontró un error al desactivar el ciclo: {cycle}",
  "inductmanagement.unselectedWarning": "Seleccione un nodo y un ciclo antes de hacer clic en activar",
  "inductmanagement.setForceError": "Se encontró un error al actualizar la inducción de fuerza para el ciclo: {CycleName}",
  "inductmanagement.deliveryWindowConfiguration": "Configuración de la ventana de entrega",
  "inductmanagement.dynamicCPlan": "Plan C. dinámico",
  "tooltip.dynamicCPlan": "Estado de planificación de contenedores para ciclos de DRS en el flujo de trabajo de Mobius. Listo: el plan de contenedores más reciente está listo, se puede iniciar la instalación. No está listo: el plan de contenedores más reciente no está listo, no se puede iniciar la inducción. Fallo mal planificado: falló debido a que se configuraron menos zonas de clasificación. ",
  "inductmanagement.getConfigFail": "Se encontró un error al intentar recuperar la configuración del ciclo de paquetes",
  "inductmanagement.setConfigFail": "Se encontró un error al intentar establecer la configuración del ciclo de paquetes",
  "inductmanagement.parallelNotEnabled": "La pestaña de inducción paralela no está habilitada para su estación",
  "inductmanagement.notEnabled": "La pestaña de configuración de la ventana de entrega programada no está habilitada en su estación",
  "inductmanagement.saveSuccess": "El cambio de configuración se envió correctamente. Los cambios pueden tardar hasta 60 minutos en aplicarse a los paquetes entrantes con entrega programada",
  "inductmanagement.noWindowsConfigured": "No se ha configurado ninguna ventana de entrega programada. Pulse editar para añadir nuevas ventanas",
  "inductmanagement.start": "Iniciar",
  "inductmanagement.end": "Fin",
  "inductmanagement.addNewWindow": "Agregar nueva ventana",
  "inductmanagement.deliveryWindow": "Ventana de entrega",
  "inductmanagement.cycles": "Ciclos",
  "inductmanagement.save": "Guardar",
  "inductmanagement.edit": "Editar",
  "inductmanagement.submit": "Enviar",
  "inductconfig.noActiveLanes": "Todos los carriles son inactivos o de retención, no quedan carriles para paletas o carros.",
  "inductconfig.noCartLanes": "Todos los carriles son inactivos, de retención o de paletas. No quedan carriles para carros.",
  "inductconfig.noBeltsConfigured": "No hay cintas de inducción configuradas. Por favor agregue al menos una cinta.",
  "inductconfig.holdLaneWarning": "No hay carriles de retención configurados. Los contenedores no pueden retenerse durante este ciclo. ¿Desea continuar?",
  "inductconfig.singleBeltWarning": "Solo una cinta activa configurada. Si esta cinta falla, no se pueden inducir paquetes. ¿Desea continuar?",
  "inductconfig.inactiveHoldOverlap": "Carril(es) inactivo(s) {lanes} no pueden estar también en carriles de retención.",
  "inductconfig.inactivePalletOverlap": "Carril(es) inactivo(s) {lanes} no pueden estar también en carriles de paletas.",
  "inductconfig.palletLanes": "Carriles de Paletas",
  "inductconfig.priorityLaneCount": "Cantidad de Carriles Prioritarios",
  "inductconfig.priorityLaneCountHint": "Ingrese la cantidad de carriles prioritarios (ej. 25)",
  "inductconfig.beltNoContainerTypes": "Una o más cintas no tienen tipos de contenedor seleccionados. Seleccione al menos un tipo de contenedor para cada cinta.",
  "inductconfig.beltNoCubeTypes": "Una o más cintas no tienen tipos de cubo seleccionados. Seleccione al menos un tipo de cubo para cada cinta.",
  "inductconfig.noActiveBelts": "No hay cintas de inducción activas configuradas. Al menos una cinta debe estar activa para procesar paquetes.",
  "inductconfig.containerTypeNotCovered": "Uno o más tipos de contenedor no están asignados a ninguna cinta activa. Todos los tipos de contenedor deben estar cubiertos por al menos una cinta activa.",
  "inductconfig.cubeTypeNotCovered": "Uno o más tipos de cubo no están asignados a ninguna cinta activa. Todos los tipos de cubo deben estar cubiertos por al menos una cinta activa.",
  "inductconfig.invalidLaneEntered": "Se ingresó un carril no válido. Por favor ingrese un identificador de carril válido.",
  "inductconfig.selectCycleBeforeUpload": "Por favor seleccione un ciclo antes de ejecutar la carga.",
  "inductconfig.invalidCycleInCsv": "Ciclo no válido o faltante en el CSV. Por favor ingrese un ciclo válido."
}